import { useState, useEffect } from 'react';

/**
 * Tracks which section is currently in view.
 *
 * Derived from the scrollY value of the shared scroll hook rather than its own
 * listener. `lockedId` lets a nav click pin the target while the smooth scroll
 * is in flight, so the indicator doesn't skip through intermediate sections.
 */
export const useScrollSpy = (
  ids: string[],
  scrollY: number,
  lockedId: string | null,
  offset = 120
) => {
  const [activeId, setActiveId] = useState(ids[0]);

  useEffect(() => {
    if (lockedId) {
      setActiveId(lockedId);
      return;
    }

    // Bottom of the page: the last section can be too short to reach the
    // offset line, so select it explicitly.
    const atBottom =
      window.innerHeight + window.scrollY >=
      document.documentElement.scrollHeight - 2;

    if (atBottom) {
      setActiveId(ids[ids.length - 1]);
      return;
    }

    let current = ids[0];
    for (const id of ids) {
      const el = document.getElementById(id);
      if (el && el.getBoundingClientRect().top <= offset) {
        current = id;
      }
    }

    setActiveId(current);
  }, [ids, scrollY, lockedId, offset]);

  return activeId;
};
